import { defineComponent, h, computed } from 'vue';
import { useInspectionReport } from '@/ui/components/inspectionReport/useInspectioReport';
import { LegacyItem } from '@/ui/components/inspectionReport/legacyTypes';
import { t, n } from '@/ui/i18n/i18n';
import TableBox from '@/ui/components/inspectionReport/items/table/TableBox.vue';
import { getDecimalPercentage, isNumberDefined } from '@/ui/helpers';
import { getScore } from '@/ui/helpers/inspectionHelper';

export const ScoreTable = defineComponent({
  name: 'ScoreTable',
  setup() {
    const { resource, isTranslationEnabled } = useInspectionReport();

    const renderTopic = (item: LegacyItem) => {
      const text = isTranslationEnabled.value && item.title_translated ? item.title_translated : item.title;
      const title = (item.params && item.params.header) ? t('inspection-report.header') : (text || '-');
      return h('td', { class: 'inspection-report__table-row' }, title);
    };

    const isMaxScoreGreaterThanZero = (maxScore: number | null | undefined) => (maxScore ?? 0) > 0;

    const itemFilter = (item: LegacyItem): boolean =>
      !item.params || !item.params.header || item.max_score === undefined || item.max_score > 0;

    const formItems = computed(() => resource.value?.form?.items ?? []);

    return function render() {
      if (
        !isNumberDefined(resource.value?.percentage)
        || !resource.value?.template?.display_score_result_of_pages
        || !resource.value?.max_score
      ) {
        return null;
      }

      return h('table', {
        class: 'mb-4 inspection-report__table',
      }, [
        h('thead', {}, [
          h('tr', {}, [
            h('td', { class: ' w-1/2 inspection-report__table-header' }, [t('inspection-report.topics')]),
            h('td', { class: 'inspection-report__table-header' }, [
              h('span', [t('inspection-report.achieved-score'),
              ])]),
            h('td', { class: 'inspection-report__table-header' }, [
              h('span', [t('inspection-report.potential-score'),
              ])]),
            h('td', { class: 'inspection-report__table-header' }, [
              h('span', [t('inspection-report.result'),
              ])]),
          ]),
        ]),
        h('tbody', {},
          formItems.value.filter(item => itemFilter(item))
            .map(item => h('tr', {}, [
              renderTopic(item),
              h(TableBox, [isMaxScoreGreaterThanZero(item.max_score) ? getScore(item.score) : '-']),
              h(TableBox, [isMaxScoreGreaterThanZero(item.max_score) ? getScore(item.max_score) : '-']),
              h(TableBox, [
                (item.max_score ?? 0) > 0 && item.percentage
                  ? n(getDecimalPercentage(item.percentage), 'scorePercentage')
                  : '-',
              ]),
            ]))),
        h('tfoot', [
          h('tr', [
            h('td', { class: 'inspection-report__table-footer' }, [h('span', t('inspection-report.total'))]),
            h('td', {
              class: 'inspection-report__table-footer',
            }, [
              isMaxScoreGreaterThanZero(resource.value?.form?.max_score)
                ? getScore(resource.value?.form?.score)
                : '-',
            ]),
            h('td', {
              class: 'inspection-report__table-footer',
            }, [
              isMaxScoreGreaterThanZero(resource.value?.form?.max_score)
                ? getScore(resource.value?.form?.max_score)
                : '-',
            ]),
            h('td', { class: 'inspection-report__table-footer' }, [
              isMaxScoreGreaterThanZero(resource.value?.form?.max_score) && resource.value.percentage
                ? n(getDecimalPercentage(resource.value.percentage), 'scorePercentage')
                : '-',
            ]),
          ]),
        ]),
      ]);
    };
  },
});
